<canvas 
    #canvas
    class="color-palette" 
    width="250" 
    height="250"
    (mousedown)="onMouseDown($event)" 
    (mousemove)="onMouseMove($event)">
</canvas>